import { useNavigate } from "@reach/router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectedCity } from "../actions";
import {fakeDelay, linkCheckSlash} from "../../provider/utility";

export default function CitySelector({ cityId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const franchises = useSelector((store) => store.data.franchises);

  useEffect(() => {
    if (cityId && franchises.length > 0) {
      const matchedFranchise = franchises.find(franchise => +franchise.id === +cityId);
      if (matchedFranchise) {
        dispatch(selectedCity({
          franchise: matchedFranchise,
          text: matchedFranchise.name,
          value: matchedFranchise.id,
        }));
        // setLoading(true);
        fakeDelay(() => {
            navigate(
            linkCheckSlash(
              location.pathname,
              '/zapisy',
            ),
          );
        });

      }
    }
  }, [cityId, franchises, dispatch, navigate]);

  return null;
}
